import {Component, OnInit} from '@angular/core';
import {routeAnimation} from '../../route.animation';
import {Title} from '@angular/platform-browser';
import {environment} from '../../../environments/environment';

@Component({
	selector: 'app-page-forbidden',
	templateUrl: './page-forbidden.component.html',
	styleUrls: ['./page-forbidden.component.scss'],
	animations: [routeAnimation]
})

export class PageForbiddenComponent implements OnInit {

	constructor(private titleService: Title) {
	}

	ngOnInit(): void {
		this.titleService.setTitle('Forbidden | ' + environment.webappName);
	}
}
